import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { TipoClassificacaoPipeModule } from '../pipes';

import { TipoClassificacaoSelectComponent } from './tipo-classificacao-select.component';

@NgModule({
    imports: [
        SharedModule,
        TipoClassificacaoPipeModule
    ],
    declarations: [
        TipoClassificacaoSelectComponent
    ],
    exports: [
        TipoClassificacaoSelectComponent
    ]
})
export class TipoClassificacaoSelectModule { }
